export default __webpack_public_path__ + "static/media/013-firefighter-1.1c0605b7.png";